//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $ from "jquery";
import cookies from "js-cookie";
import {
  global,
  getQueryString,
  getTouchType,
  getSuperiorPage,
  isElementInViewport
} from "../common/util";
import { sensors } from "../common/sensors";
import share from "../common/share";
import { FIND_DETAIL, GET_LOGIN_USER } from "../common/apiPath";

export default {
  name: "index",
  data() {
    return {
      error: false,
      title: "",
      bgColor: null,
      templateValues: [],
      pageId: "",
      populationActivityCode: "",
      populationChannelCode: "",
      activityStatus: 0,
      waitGetLogin: false, // 等待判断登录接口
      hasNavBottom: false,
      belongSystem: "ows" // 判断不同系统 {ows: 预售房, score-mall: 积分商城}
    };
  },
  components: {
    singlePic: () => import("@/components/singlePic.vue"),
    pictureCube: () => import("@/components/pictureCube.vue"),
    hotelList: () => import("@/components/hotelList.vue"),
    coupon: () => import("@/components/coupon.vue"),
    navBottom: () => import("@/components/navBottom.vue"),
    rotationPicture: () => import("@/components/rotationPicture.vue"),
    score: () => import("@/components/score.vue"),
    lottery: () => import("@/components/lottery.vue"),
    register: () => import("@/components/register.vue"),
    exchangeCode: () => import("@/components/exchangeCode.vue"),
    pictureNavigation: () => import("@/components/pictureNavigation.vue"),
    goodsGroup: () => import("@/components/goodsGroup.vue"),
    hotelListYushoufang: () => import("@/components/hotelListYushoufang.vue"),
    member: () => import("@/components/member.vue")
  },
  created() {
    this.pageInit();
  },
  mounted() {
    sensors.init();
  },
  methods: {
    async pageInit() {
      const res = await this.$http.get(FIND_DETAIL, {
        params: {
          id: this.$route.params.id
        },
        type: this.$route.query.type
      });
      const { data } = res;
      if (data) {
        // 存在底部导航
        this.hasNavBottom = data.templateValues.some(item => item.type === "navigation");
        this.getLogin();

        this.bgColor = data.bgColor;
        document.body.style.backgroundColor = data.bgColor;
        this.pageId = data.id;
        this.populationActivityCode = data.populationActivityCode;
        global.populationActivityCode = data.populationActivityCode;
        this.populationChannelCode = data.populationChannelCode;
        global.populationChannelCode = data.populationChannelCode;
        this.templateValues = data.templateValues;
        data.belongSystem && (this.belongSystem = data.belongSystem);
        document.title = data.title;
        this.title = data.title;
        this.error = false
        // 分享
        if (process.env.NODE_ENV !== "dev") {
          share(this, {
            title: data.shareTitle,
            img: data.shareCover,
            desc: data.shareDesc
          });
        }
        if (res.serverTime >= data.startTime && res.serverTime <= data.endTime) {
          this.activityStatus = 0;
        } else if (res.serverTime < data.startTime) {
          this.activityStatus = 1;
        } else {
          this.activityStatus = 2;
        }
        const sensorsObj = {
          trigger_type: "页面曝光",
          superior_page: getTouchType(),
          touch_type: getSuperiorPage(),
          activity_name: data.title,
          template_module: "-",
          template_module_name: "-",
          check_content: "页面曝光"
        };
        sensors.track("marketing_template", sensorsObj);
      } else {
        this.error = true
      }
    },
    async getLogin() {
      if (getQueryString("owsToken")) {
        if (decodeURIComponent(getQueryString("owsToken")).length > 2) {
          cookies.set("ows_token", getQueryString("owsToken"), {
            domain: ".lvyuetravel.com",
            expires: 15 * 60 * 1000,
            path: "/"
          });
          global.isLogin = true;
        } else {
          cookies.remove("ows_token", { domain: ".lvyuetravel.com", path: "/" });
          cookies.remove("p_oid", { domain: ".lvyuetravel.com", path: "/" });
        }
      }

      // 把url上的p_oid传入
      if (getQueryString("p_oid")) {
        cookies.set("p_oid", getQueryString("p_oid"), {
          domain: ".lvyuetravel.com",
          expires: 60 * 60 * 1000,
          path: "/"
        });
      }

      if (cookies.get("ows_token") || cookies.get("p_oid")) {
        global.isLogin = true;
      }

      // 走获取用户信息确保判断登录准确
      const res = await this.$http.get(GET_LOGIN_USER);
      if (!res.data) {
        global.isLogin = false;
      } else {
        global.isLogin = true;
        global.userInfo = res.data;
      }
      this.waitGetLogin = true;
      const that = this;

      $(document).on("click", "#app > .wrap-body > div > div", function b() {
        if (!that.templateValues.length) return;
        const index = $(this).index();
        if (that.templateValues[index] && that.templateValues[index].name) {
          const templateItem = that.templateValues[index];
          const sensorsObj = {
            trigger_type: "点击",
            superior_page: getTouchType(),
            touch_type: getSuperiorPage(),
            activity_name: that.title,
            template_module: index,
            template_module_name: templateItem.name,
            check_content: templateItem.name
          };
          sensors.track("marketing_template", sensorsObj);
        }
      });

      setTimeout(() => {
        $(document)
          .on("scroll", () => {
            $("#app > .wrap-body > div > div").each((index, e) => {
              if (!$(e).attr("sensors")) {
                if (isElementInViewport(e)) {
                  $(e).attr("sensors", true);
                  const sensorsObj = {
                    trigger_type: "组件曝光",
                    superior_page: getTouchType(),
                    touch_type: getSuperiorPage(),
                    activity_name: that.title,
                    template_module: index,
                    template_module_name: this.templateValues[index].name,
                    check_content: this.templateValues[index].name
                  };
                  sensors.track("marketing_template", sensorsObj);
                }
              }
            });
          })
          .trigger("scroll");
      }, 1000);
    },
    reLoad() {
      window.location.reload();
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/index.vue